import { useEffect, useState } from 'react';
import { AtendentesService } from '../../../atendentes/Service';
import { baseURL } from '../../../../AxiosConfig';
import { initials, LoadFailure } from '../../booking/BookingParts';
import { useFormHorarioClienteContext } from './Context';

const serviceAtendentes = new AtendentesService();

export const SelectAtendente = () => {
    const [status, setStatus] = useState<'loading' | 'error' | 'ready'>('loading');
    const [atendentes, setAtendentes] = useState([] as any[]);
    const [retry, setRetry] = useState(0);
    const { estab, setAtendente, setAttendantCount } = useFormHorarioClienteContext();

    useEffect(() => {
        if (!estab?._id) return;
        let current = true;
        setStatus('loading');
        serviceAtendentes
            .getByEstabId(estab._id, '__all__')
            .then(({ data }) => {
                if (!current) return;
                const list = Array.isArray(data) ? data : [];
                setAtendentes(list);
                setAttendantCount(list.length);
                setStatus('ready');
                // Com um unico profissional nao ha o que escolher: segue direto para os servicos.
                if (list.length === 1) setAtendente(list[0]);
            })
            .catch(() => {
                if (current) setStatus('error');
            });
        return () => {
            current = false;
        };
    }, [estab?._id, retry]);

    if (status === 'loading') {
        return (
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" role="status" aria-label="Carregando profissionais">
                {[0, 1, 2, 3].map((item) => <div key={item} className="sf-skeleton h-36 rounded-2xl" />)}
            </div>
        );
    }

    if (status === 'error') {
        return <LoadFailure message="Não foi possível carregar os profissionais." onRetry={() => setRetry((value) => value + 1)} />;
    }

    if (!atendentes.length) {
        return <p className="py-10 text-center text-sm text-base-content/70">Nenhum profissional disponível no momento.</p>;
    }

    return (
        <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
            {atendentes.map((item: any) => (
                <li key={item?.uid}>
                    <button
                        type="button"
                        className="flex h-full w-full flex-col items-center gap-3 rounded-2xl bg-base-100 px-3 py-5 ring-1 ring-base-content/[0.06] transition-colors hover:bg-base-100/70 active:bg-base-content/5"
                        onClick={() => setAtendente(item)}
                    >
                        <span className="relative flex h-20 w-20 items-center justify-center overflow-hidden rounded-full bg-base-200 text-xl font-semibold text-base-content/40">
                            {initials(item?.displayName)}
                            <img
                                src={`${baseURL}/users/profileImage/${item?.uid}`}
                                alt=""
                                className="absolute inset-0 h-full w-full object-cover"
                                onError={(event) => { event.currentTarget.hidden = true; }}
                            />
                        </span>
                        <span className="break-words text-center text-[0.9375rem] font-medium text-base-content">{item?.displayName}</span>
                    </button>
                </li>
            ))}
        </ul>
    );
};
